var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApplogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 35.718,
    viewBox: "0 0 31 35.718",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_9",
    "data-name": "Fill 9",
    d: "M.882,2.756A4.986,4.986,0,0,1,3.774,1.549,4.95,4.95,0,0,1,6.658,2.756q.564.4.88-.475A2.256,2.256,0,0,0,6.647.962,5.135,5.135,0,0,0,3.774,0,5.158,5.158,0,0,0,.9.962,2.229,2.229,0,0,0,0,2.28q.316.891.882.475",
    transform: "translate(4.151 10.89)",
    fill: "#f79445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_10",
    "data-name": "Fill 10",
    d: "M15.5,35.718h0a24.074,24.074,0,0,1-7.75-4.158A20.6,20.6,0,0,1,2.422,25.23,21.274,21.274,0,0,1,0,15.056V2.32a.331.331,0,0,1,.333-.328A.343.343,0,0,1,.414,2l3.526.86V.429L8.417,2.845V.34L15.4,5.525,19.9,0V3.78L23.963.774V3.617L30.587,2a.343.343,0,0,1,.081-.01A.331.331,0,0,1,31,2.32V15.056a21.28,21.28,0,0,1-2.422,10.176,20.592,20.592,0,0,1-5.328,6.331,24.057,24.057,0,0,1-7.75,4.155Zm.014-17.2a13.815,13.815,0,0,1-4.53,4.764,11.817,11.817,0,0,1-5.918,1.9,23.879,23.879,0,0,0,6.494,6.036A36.038,36.038,0,0,0,15.5,33.537a40.827,40.827,0,0,0,4.089-2.459,24.04,24.04,0,0,0,6.388-5.984,12.637,12.637,0,0,1-5.1-1.49,10.855,10.855,0,0,1-2.881-2.043c-.079-.08-.156-.163-.231-.244l-.051-.055A15.357,15.357,0,0,1,15.513,18.516ZM2.241,4.385a.331.331,0,0,0-.332.328V15.056a17.048,17.048,0,0,0,1.773,7.982c.243.032.468.052.688.061H4.4a12.224,12.224,0,0,0,5.37-1.519,11.436,11.436,0,0,0,2.434-2.066,10.224,10.224,0,0,0,2.243-6.252V7.355L2.322,4.395A.341.341,0,0,0,2.241,4.385Zm26.51.006a.342.342,0,0,0-.082.01L16.541,7.36v6.688a11.313,11.313,0,0,0,1.212,4.019,11.235,11.235,0,0,0,9.13,4.974c.14,0,.283,0,.423-.009a17,17,0,0,0,1.78-7.973l0-10.341a.322.322,0,0,0-.1-.233A.333.333,0,0,0,28.752,4.391Z",
    fill: "#f79445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_11",
    "data-name": "Fill 11",
    d: "M3.807,0A9.972,9.972,0,0,1,0,4.028L3.807,9.653,7.612,4.028A9.938,9.938,0,0,1,3.807,0",
    transform: "translate(11.693 21.542)",
    fill: "#f79445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_12",
    "data-name": "Fill 12",
    d: "M6.648.962A5.135,5.135,0,0,0,3.774,0,5.159,5.159,0,0,0,.9.962,2.229,2.229,0,0,0,0,2.28q.316.891.883.475A4.985,4.985,0,0,1,3.774,1.549,4.95,4.95,0,0,1,6.658,2.756q.565.4.88-.475A2.254,2.254,0,0,0,6.648.962",
    transform: "translate(19.188 10.89)",
    fill: "#f79445"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplogo);
export default __webpack_public_path__ + "static/media/Applogo.e0ec468c73a51daee29904e2b3ca496c.svg";
export { ForwardRef as ReactComponent };